import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { HelpCategoryPage } from '~/components/Help/HelpCategoryPage';
import { HelpCategoryRedirect } from '~/components/Help/HelpCategoryRedirect';

export const HelpRouteSwitch = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}/category`} exact component={HelpCategoryRedirect} />
      <Route path={`${path}/category/:categoryId`} component={HelpCategoryPage} />
      <Redirect from={path} to={`${path}/category`} />
    </Switch>
  );
};
